/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/
import { Select } from '@react-three/postprocessing'
import { useEffect, useMemo, type JSX } from 'react'
import { Matrix4, Vector2, type Mesh } from 'three'
import { mergeGeometries } from 'three/examples/jsm/utils/BufferGeometryUtils.js'

import { useColorMapGLTF } from '@hooks'

interface GLTFResultNodes {
  ['train-locomotive-passenger-a_1']: Mesh
  ['wheels-front']: Mesh
  ['wheels-back']: Mesh
}

type WagonAModelProps = JSX.IntrinsicElements['group'] & { color?: string; highlight?: boolean }

export function WagonAModel({ color = '#f59e0b', highlight = false, ...props }: WagonAModelProps) {
  const { nodes, material } = useColorMapGLTF<GLTFResultNodes>(
    '/models/train/train-locomotive-passenger-a.glb',
    'train',
    {
      colorUV: new Vector2(0.31, 0.375),
      colorUVThreshold: 0.5,
      color,
    },
  )

  const mergedGeometry = useMemo(() => {
    return mergeGeometries([
      nodes['train-locomotive-passenger-a_1'].geometry,
      nodes['wheels-front'].geometry
        .clone()
        .applyMatrix4(new Matrix4().makeTranslation(0, 0.359, 0.7)),
      nodes['wheels-back'].geometry
        .clone()
        .applyMatrix4(new Matrix4().makeTranslation(0, 0.359, -0.4)),
    ])
  }, [nodes])

  useEffect(() => {
    return () => {
      mergedGeometry?.dispose()
    }
  }, [mergedGeometry])

  return (
    <group {...props}>
      <Select enabled={highlight}>
        <mesh castShadow receiveShadow geometry={mergedGeometry} material={material} />
      </Select>
    </group>
  )
}

useColorMapGLTF.preload('/models/train/train-locomotive-passenger-a.glb')
